import Main from '~/components/Main'
import Header from '~/components/Header'
import { PageBanner } from '~/components/PageBanner'

import styles from './DefaultLayout.pcss'
import { Outlet } from 'react-router-dom'
import React from 'react'

const DefaultLayout: React.FC = () => {
	return (
		<div className={styles.layout}>
			<PageBanner />
			<Header />
			<Main>
				<Outlet />
			</Main>
		</div>
	)
}

export default DefaultLayout
